const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const getStripeData = endpointHelias+"/Helias/V0/UserAccount/getStripeData"

var initialConfigCommonJS = require("../js/initialConfigCommon.js")

exports.cargarPlanesStripe = function(){
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');    
    script.async = true;    
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    head.appendChild(script);
}

exports.verificarSuscripcion = function(funcionEjecucionTrasVerificacion){

  var continuarEjecucion = true

  var datosStripeActuales = {}

  if( (localStorage.getItem("stripeData") !== null) && (Object.keys(JSON.parse(localStorage.getItem("stripeData")).length > 0)) ){
    datosStripeActuales = JSON.parse(localStorage.getItem("stripeData"))        
  }        

  try{
    
    if( (datosStripeActuales.priceId !== "N/A") && (datosStripeActuales.priceId !== undefined) ){     

        if(datosStripeActuales.active !== "True"){
                      
          //Si tiene un plan configurado pero está inactivo es porque le ha caducado la suscripción así que le muestro el mensaje.

          var datosStripe = {}
            
          if( (localStorage.getItem("stripeData") !== null) && (Object.keys(JSON.parse(localStorage.getItem("stripeData")).length > 0)) ){
            datosStripe = JSON.parse(localStorage.getItem("stripeData"))        
          } 

          module.exports.obtenerMensajeErrorSuscripcion(datosStripe, "SuscripcionCaducada")   
          continuarEjecucion = false
            
        }              
    }
    else{                       
        //Si directamente es que no tiene plan es un usuario ya registrado que viene del Betatesting, así que le muestro los planes
        localStorage.removeItem("installationConfigurationMode")
        window.location.href = "/Logout"
    }                  
  
    if(continuarEjecucion){
      funcionEjecucionTrasVerificacion()  
    }

    localStorage.setItem("initialCheck","true")

  }
  catch(error){    
    console.log(error)
    window.location.href = "/Logout"
  }
    
}

exports.obtenerMensajeErrorSuscripcion = function(datosStripe, tipoOperacion){
  
  var planActual = datosStripe.priceId
  var linkSuscripcion = ""

  //VER QUÉ LINK METO AQUÍ.........................................................................................  

  var iconoPlanActual = ""

  if(planActual !== "PH-M"){ //Si está en el plan antiguo le llevo a la nueva contratación
    planActual = "PH-M"
  }

  if(datosStripe.active === "False"){ //Si es suscripción cancelada / expirada (Periodo 7 días de gracia) les llevo a la nueva contratación        
    document.getElementById("linkLimiteSuscripcionModificar").href = module.exports.linkCheckout()
  }
  else{ // Si la suscripción sigue activa le llevo al portal.    
    document.getElementById("linkLimiteSuscripcionModificar").href = datosStripe.portalLink
  }

  // ICONOS
  if(planActual.includes("PH")){ //Plan helias    
    iconoPlanActual = "https://fevergy.com/images/helias.png"          
  }
  else if(planActual.includes("PB")){ //Plan básico    
    iconoPlanActual = "https://fevergy.com/images/basic.png"          
  }
  else if(planActual.includes("PA")){ //Plan avanzado
    // 2 Apps. Dispositivos                 
    iconoPlanActual = "https://fevergy.com/images/advanced.png"    
  }
  else if(planActual.includes("PR")){ //Plan premium
    // 6 Apps. Dispositivos
    iconoPlanActual = "https://fevergy.com/images/premium.png"          
  }

  var suscripcionNecesaria = ""    
  var textoBotonLimiteSuscripcion = "Cambiar plan"

  // LÓGICA EN FUNCIÓN DEL CASO

  if (tipoOperacion === "SuscripcionCaducada"){

    try{
    
      var timestampAhora = parseInt(Date.now() / 1000)
      var timestampFinalizacionSuscripcion = datosStripe.currentPeriodEnd
      var diasRestantesReactivacion = 7 - parseInt((timestampAhora - timestampFinalizacionSuscripcion) / 86400)

      var mensajePlanExpirado = ""
      
      if(datosStripe.status === "canceled"){ //Cancelada
        mensajePlanExpirado = "<strong>" + module.exports.obtenerNombrePlanDePago(datosStripe) + "</strong> de tu instalación <strong>" + localStorage.getItem("installationName").split("*")[1] + " ha sido cancelado. Si una suscripción a un plan se cancela ya no se puede reactivar</strong>."              
      }
      else{ //Caducada

        if(planActual.includes("PH")){ //Plan helias    

          mensajePlanExpirado = "<strong>Suscripción " + module.exports.obtenerNombrePlanDePago(datosStripe) + " caducada</strong>. "        
          mensajePlanExpirado = mensajePlanExpirado + "Todavía tienes <strong>"+diasRestantesReactivacion
              
          if(diasRestantesReactivacion > 1){
            mensajePlanExpirado = mensajePlanExpirado +" días" 
          }
          else{
            mensajePlanExpirado = mensajePlanExpirado +" día"  
          }

          mensajePlanExpirado = mensajePlanExpirado + " para reactivarla</strong>. Terminado el plazo tu cuenta será eliminada automáticamente."

        }
        else{
          mensajePlanExpirado = "<strong>" + module.exports.obtenerNombrePlanDePago(datosStripe) + " caducado</strong>. "        
          mensajePlanExpirado = mensajePlanExpirado + "Todavía tienes <strong>"+diasRestantesReactivacion
              
          if(diasRestantesReactivacion > 1){
            mensajePlanExpirado = mensajePlanExpirado +" días" 
          }
          else{
            mensajePlanExpirado = mensajePlanExpirado +" día"  
          }

          mensajePlanExpirado = mensajePlanExpirado + " para reactivarlo</strong>. Terminado el plazo tu cuenta será eliminada automáticamente."
        }
        
      }

      document.getElementById("textoLimitesSuscripcion").innerHTML = mensajePlanExpirado

      // Ahora analizo cual sería la suscripción que necesitaría para mantener esta configuración
      suscripcionNecesaria = "Suscripción caducada"
      textoBotonLimiteSuscripcion = "Renovar suscripción"
      linkSuscripcion = ""      

      //Paro todos los refrescos automáticos
      for (var i = 1; i < 99999; i++)
        window.clearInterval(i);
          
      document.getElementById("iconoLimitesSuscripcion").className = document.getElementById("iconoLimitesSuscripcion").className.replaceAll("blink", "")
      document.getElementById("cuadroEliminacionElementosSuscripcion").className = document.getElementById("cuadroEliminacionElementosSuscripcion").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("linkLimiteSuscripcionModificar").className = document.getElementById("linkLimiteSuscripcionModificar").className.replaceAll(" hidden", "")
      document.getElementById("linkLimiteSuscripcionModificar").innerHTML = textoBotonLimiteSuscripcion                 
      document.getElementById("linkVolverProblemaSuscripcion").className = document.getElementById("linkVolverProblemaSuscripcion").className.replaceAll(" hidden", "") + " hidden"      
      document.getElementById("linkElementosSuscripcionSalir").className = document.getElementById("linkElementosSuscripcionSalir").className.replaceAll(" hidden", "")

      if(localStorage.getItem("installationName").includes("INSTALADOR-")){
        document.getElementById("linkElementosSuscripcionSalir").innerHTML = "Volver a listado de instalaciones"      
      }
      else{ //Salir normal
        document.getElementById("linkElementosSuscripcionSalir").innerHTML = "Salir"      
      }

      if (localStorage.getItem("installationName") !== null){
        
        document.getElementById("linkSeleccionarInstalacionErrorSuscripcion").className = document.getElementById("linkSeleccionarInstalacionErrorSuscripcion").className.replaceAll(" hidden", "") + " hidden"
                
      }

      document.getElementById("divLimitesSuscripcion").className = document.getElementById("divLimitesSuscripcion").className.replaceAll(" hidden", "")    
      document.getElementById("iconoLimitesSuscripcion").src = iconoPlanActual                      


      if(datosStripe.status === "canceled"){ //Cancelada
        document.getElementById("linkLimiteSuscripcionModificar").className = document.getElementById("linkLimiteSuscripcionModificar").className.replaceAll(" hidden", "") + " hidden"
      }

    }
    catch(error){
      /* control de carga prematura de dashboard */
      console.log(error)
    }

  }
    
  var respuestaMensaje = {
    "iconoPlanActual":iconoPlanActual,
    "suscripcionNecesaria":suscripcionNecesaria,
    "linkSuscripcion":linkSuscripcion,
    "textoBotonLimiteSuscripcion":textoBotonLimiteSuscripcion
  }

  return respuestaMensaje

}

exports.linkPortalStripeUsuario = function(){

    document.getElementById("divLimitesSuscripcion").className = document.getElementById("divLimitesSuscripcion").className.replaceAll(" hidden", "") + " hidden"

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
            
    //Petición de datos para el paso actual      
    var jsonPeticion = { "accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId") }
    
    document.getElementById("loaderGeneralAplicacion").className = "loader overlay"

    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", getStripeData, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
            var jsonRespuesta = JSON.parse(this.responseText)

            if(jsonRespuesta.statusCode === "403"){                           
                initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
            }                
            else{                                      
                jsonRespuesta = JSON.parse(this.responseText).body

                //Obtengo los datos de stripe 
                console.log("Link portal Stripe usuario cargado correctamente.")  
                
                // Para el link de portal uso la respuesta del sevicio
                if(jsonRespuesta.portalLink !== ""){ window.location.href = jsonRespuesta.portalLink }
                else{ window.location.href = "/Dashboard" }

            }
        
            if (this.readyState === 4 && this.status !== 200) {      
                initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
            }
        }
    }    
    xhttp.send(data);             

}

exports.obtenerNombrePlanDePago = function(objPlan){
  
    var idPlan = objPlan.priceId
    var planIsActive = objPlan.active
    var planStatus = objPlan.status
    var nombrePlan = ""
  
    try{
      var tituloSuscripcion = document.getElementById("tituloSuscripcion").innerHTML
    }
    catch(error){/* Controlo el caso de carga desde la modal de acceso de suscripción caducada*/}
  
    // El primero es el ID de TEST, el segundo es el ID de PROD

    if(idPlan !== "N/A"){
    
      if(idPlan === "PH-M"){ 
        nombrePlan = "Helias" 
        tituloSuscripcion = "Suscripción"
      }
      else if(idPlan === "PR-A"){ 
        nombrePlan = "Plan Premium" 
        tituloSuscripcion = "Suscripción anual"
      }
      else if(idPlan === "PR-M"){ 
        nombrePlan = "Plan Premium" 
        tituloSuscripcion = "Suscripción mensual"
      }
      else if(idPlan === "PA-A"){ 
        nombrePlan = "Plan Avanzado" 
        tituloSuscripcion = "Suscripción anual"
      }
      else if(idPlan === "PA-M"){ 
        nombrePlan = "Plan Avanzado" 
        tituloSuscripcion = "Suscripción mensual"
      }
      else if(idPlan === "PB-A"){ 
        nombrePlan = "Plan Básico" 
        tituloSuscripcion = "Suscripción anual"
      }
      else if(idPlan === "PB-M"){ 
        nombrePlan = "Plan Básico" 
        tituloSuscripcion = "Suscripción mensual"
      }
  
      if(planStatus === "trialing"){
        tituloSuscripcion = tituloSuscripcion + " en periodo de prueba"
      }
  
      if(planIsActive !== "True"){          
        tituloSuscripcion = tituloSuscripcion + " <strong>[ CADUCADA ]</strong>"        
      }  
    
    }
    else{
      nombrePlan = "Sin plan contratado, debes contratar uno para poder usar Helias"
    }
  
    try{
      document.getElementById("tituloSuscripcion").innerHTML = tituloSuscripcion
    }
    catch(error){/* Controlo el caso de carga desde la modal de acceso de suscripción caducada*/}

    return nombrePlan
  
}